// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-rlsbxxcx-index-main_right_content-3EDdN","table":"components-tjcx-rlsbxxcx-index-table-RY-_w"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/rlsbxxcx/index.css
// module id = 2312
// module chunks = 0